import { GalleryCarouselTypes } from "@app/types/Opensearch.d";
import { SocialVariant } from "@components/Blocks/ShareSocial/ShareSocial";
import ShareSocialNew from "@components/Blocks/ShareSocial/ShareSocialNew";
import ArticleCarousel from "@components/Layouts/Carousel/ArticleCarousel";
import ArticleParagraph from "@elements/ArticleParagraph/ArticleParagraph";
import Date from "@elements/Typography/Date";
import Heading from "@elements/Typography/Heading";
import Link from "@elements/Typography/Link";
import { StandFirst } from "@elements/Typography/Paragraph";
import { RenderTags } from "@elements/Typography/Tags";
import { SectionTitleV2 } from "@elements/Typography/TitleV2";
import { isArrayWithElements } from "@helper/utils";
import ArticleElementWrapper from "@pages/Article/Components/ArticleElementWrapper";
import { ShareSocialBar } from "@pages/Article/Components/ShareSocialBar";
import { MATA_MATA_SECTION } from "@pages/UGC/UGCLandingPage/UGCLandingPage";
import { ProcessedArticleData } from "@transformer/useOSResponse";
import {
  AdTargetingType,
  ArticleAdTargetKeys,
  PageAdTargetValue,
} from "@typings/Ads.d";
import React from "react";

export type UGCArticleContentCardNewProps = {
  mainArticle: ProcessedArticleData;
  pageAdTargetValue: PageAdTargetValue;
  pageNumber: number;
  isInfiniteScrollArticle?: boolean;
  gsChannels?: string[];
  articleSlotTarget?: AdTargetingType<ArticleAdTargetKeys, string>[];
  index?: number;
};

export default function UGCArticleContentCardNew({
  mainArticle,
  pageNumber,
  isInfiniteScrollArticle = false,
  gsChannels,
  articleSlotTarget,
  index,
}: UGCArticleContentCardNewProps) {
  const {
    title,
    tags,
    date,
    dateCreated,
    time,
    articleBody,
    standFirst,
    contentAccess,
    urlPath,
    imageGallery,
    relatedArticles,
    attachments,
    id,
    campaignReference,
  } = mainArticle;
  const socialIconList = ["facebook", "telegram", "plainWhatsapp"];
  const pageUrl = `${urlPath}`;
  const renderItems = imageGallery.filter(
    (item) => item.type !== GalleryCarouselTypes.UNKNOWN,
  );

  return (
    <React.Fragment key={index}>
      <ArticleElementWrapper>
        <div
          className={`flex items-center justify-between pb-3 mb-3 border-b-2 border-blue-300`}
        >
          <SectionTitleV2
            Element={Link}
            elementLink={`mata-mata/${campaignReference?.href.split("/").at(-1)}`}
            className="text-[16px] lg:text-[12px] lg:font-semibold mb-0 leading-[120%] text-blue-300 hover:text-blue-700 hover:underline"
            sectionName={campaignReference?.title as string}
            parentSection={MATA_MATA_SECTION}
            iconStyle="hidden"
          />
          <ShareSocialBar
            dateCreated={dateCreated}
            pageUrl={pageUrl}
            socialIconList={socialIconList}
            title={title}
          />
        </div>
        <div className="flex flex-col gap-[5px] mb-3">
          <Heading
            Element="h1"
            className="font-secondary leading-[120%] text-black-800 text-[22px] lg:text-[38px] font-medium"
          >
            {title}
          </Heading>
          {standFirst && (
            <StandFirst className="text-xs lg:text-xs font-primary font-[500] leading-[150%] text-grey-350">
              {standFirst}
            </StandFirst>
          )}
        </div>
        {/* Tags dont dont render If alias not available in payload*/}
        <RenderTags tagsWrapper="my-3 gap-[10px]" tags={tags} />
        <div className="flex mb-3">
          <Date
            date={date}
            time={time}
            variant={"or"}
            className="text-[14px] font-semimedium leading-[150%] text-black-700"
          />
        </div>
        {isArrayWithElements(renderItems) && (
          <ArticleCarousel
            renderItems={renderItems}
            sectionName={MATA_MATA_SECTION}
            wrapperClass="max-w-[860px]"
          />
        )}
      </ArticleElementWrapper>

      <ArticleParagraph
        articleId={id}
        contentAccess={contentAccess}
        articleBody={articleBody}
        uniqueSectionName={MATA_MATA_SECTION}
        relatedArticles={relatedArticles}
        pageNumber={pageNumber}
        isInfiniteScrollArticle={isInfiniteScrollArticle}
        gsChannels={gsChannels}
        articleSlotTarget={articleSlotTarget}
        adsUniqueSectionName={MATA_MATA_SECTION}
        attachments={attachments}
        tags={tags}
      />

      <ArticleElementWrapper>
        <div className="flex self-end items-center justify-end">
          {socialIconList.map((variant, index) => (
            <ShareSocialNew
              variant={variant as SocialVariant}
              pagePath={pageUrl}
              pageTitle={title}
              dateCreated={dateCreated}
              key={index}
            />
          ))}
        </div>
      </ArticleElementWrapper>
    </React.Fragment>
  );
}
